<template>
  <div>
    <div class="row">
      <div class="col">
        <card class="card">
          <div v-if="avanzamento == 1">
            <form>
              <label for="azienda"><strong>AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
              <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
              <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
              <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
              <label for="tel"><strong>TEL </strong></label>
              <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
              <label for="mail"><strong>MAIL </strong></label>
              <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
              <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
              <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
              <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
            </form> 
          </div>

          <!-- SATEC -->
          <div v-if="avanzamento == 2">
            <div v-if="user_livello==1 || user_livello==4 || user_livello==5">
              <!-- SATEC AGGIUNGE I SUOI DATI-->
              <form>
                <!-- ASCOM -->
                <label for="azienda"><strong>AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
                <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
                <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
                <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
                <label for="tel"><strong>TEL </strong></label>
                <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
                <label for="mail"><strong>MAIL </strong></label>
                <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
                <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
                <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
                <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
                <!-- SATEC -->
                <p><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato"></label></p>
                <p><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento"></label></p>
                <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
                <input type="datetime-local" class="form-control" name="data_appuntamento" v-model="data_appuntamento">

                <p><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
                <label for="note"><strong>NOTE</strong></label>
                <input type="text" class="form-control" name="note" v-model="note">

                <label for="mail"><strong>INVIO EMAIL AL SUPERVISORE</strong></label>
                <input type="text" class="form-control" name="mail" v-model="email">
                <button class="btn float-right" type="button" v-on:click="inviaEmail()" style="margin-bottom: 10px;background:#00467f">Invia email</button>{{rispostaEmail}}

                <div v-if="id_checklist_sop != null">
                  <button class="btn float-left" type="button" v-on:click="checklist()" style="margin-bottom: 10px;background:#00467f">Visualizza checklist</button>
                </div>

                <div style="clear: both;"></div>

                <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
                <input type="datetime-local" class="form-control" name="data_sopraluogo" v-model="data_sopraluogo" required>
                <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" required>
                <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC </strong><span v-if="attivita_preventivate_satec != null"><i v-if="attivita_preventivate_satec.length > 300" style="color: red">({{attivita_preventivate_satec.length}})</i><i v-else style="color: green">({{attivita_preventivate_satec.length}})</i></span></label>
                <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" required>
                <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO </strong><span v-if="attivita_preventivate_prezzo != null"><i v-if="attivita_preventivate_prezzo.length > 300" style="color: red">({{attivita_preventivate_prezzo.length}})</i><i v-else style="color: green">({{attivita_preventivate_prezzo.length}})</i></span></label>
                <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" required>
              </form> 
            </div>
            <div v-else>
              <!-- ASCOM VEDE COME SE FOSSE AVANZAMENTO==1 PERCHè SATEC NON HA ANCORA AGGIUNTO I DATI -->
              <form>
                <!-- ASCOM -->
                <label for="azienda"><strong>AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
                <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
                <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
                <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
                <label for="tel"><strong>TEL </strong></label>
                <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
                <label for="mail"><strong>MAIL </strong></label>
                <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
                <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
                <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
                <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
                <!--  -->
                <span v-if="chiamato">
                  <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
                  <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
                  <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
                  <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
                </span>
                <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
                <label for="note"><strong>NOTE</strong></label>
                <input type="text" class="form-control" name="note" v-model="note">

                <label for="mail"><strong>INVIO EMAIL AL SUPERVISORE</strong></label>
                <input type="text" class="form-control" name="mail" v-model="email">
                <button class="btn float-right" type="button" v-on:click="inviaEmail()" style="margin-bottom: 10px;background:#00467f">Invia email</button>{{rispostaEmail}}

              </form>
            </div>
          </div>
            
           <div v-if="avanzamento == 3">
            <!-- SATEC AGGIUNGE I SUOI DATI-->
            <form>
              <!-- ASCOM -->
              <label for="azienda"><strong>AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
              <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
              <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
              <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
              <label for="tel"><strong>TEL </strong></label>
              <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
              <label for="mail"><strong>MAIL </strong></label>
              <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
              <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
              <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
              <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
              <!-- SATEC -->
              <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
              <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
              <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
              <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
              
              <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
              <label for="note"><strong>NOTE</strong></label>
              <input type="text" class="form-control" name="note" v-model="note">

              <label for="mail"><strong>INVIO EMAIL AL SUPERVISORE</strong></label>
              <input type="text" class="form-control" name="mail" v-model="email">
              <button class="btn float-right" type="button" v-on:click="inviaEmail()" style="margin-bottom: 10px;background:#00467f">Invia email</button>{{rispostaEmail}}

              <div v-if="id_checklist_sop != null">
                  <button class="btn float-left" type="button" v-on:click="checklist()" style="margin-bottom: 10px;background:#00467f">Visualizza checklist</button>
              </div>

              <div style="clear: both;"></div>

              <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
              <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
              <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
              <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>

              <!-- <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="nome_attivita">Nome attività</label>
                  <input type="text" class="form-control" v-model="nome_attivita">
                </div>
                <div class="form-group col-md-4">
                  <label for="prezzo_satec_attivita">Prezzo Satec</label>
                    <div class="input-icon">
                      <input type="number" class="form-control" v-model="prezzo_satec_attivita" id="prezzo_satec_attivita" placeholder="0.00">
                      <i>€</i>
                    </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="prezzo_consigliato_attiva">Prezzo Consigliato</label>
                  <div class="input-icon">
                    <input type="number" class="form-control" v-model="prezzo_consigliato_attiva" id="prezzo_consigliato_attiva" placeholder="0.00" >
                    <i>€</i>
                  </div>
                </div>
                <div class="form-group col-md-1">
                  <i class="fas fa-plus-circle" style="font-size:35px;margin-top:20px;color:#00467f" v-on:click="addAttivita()"></i>
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group col-md-6">
                    <table class="table tablesorter" id="tabella" style="text-align: center" v-if="attivita_array.length > 0">
                      <thead>
                        <tr>
                          <th>NOME ATTIVITÀ</th>
                          <th>PREZZO SATEC (senza IVA)</th>
                          <th>PREZZO CONSIGLIATO (senza IVA)</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="row-color" v-for="(valori, index) in attivita_array" v-bind:key="index">
                          <td>{{valori.NOME_ATTIVITA}}</td>
                          <td>{{valori.PREZZO_SATEC}} €</td>
                          <td>{{valori.PREZZO_CONSIGLIATO}} €</td>
                          <td><i class="fa fa-times-circle" style="font-size:25px;color:#00467f" @click="removeAttivita(index)"></i></td>
                        </tr>
                      </tbody>
                    </table>
                </div>
              </div>-->
            </form> 
          </div>
          <!-- ASCOM -->
          <div v-if="avanzamento == 4">
            <div v-if="user_livello==1 || user_livello==2 || user_livello==3">
              <form>
                <!-- ASCOM -->
                <label for="azienda"><strong>AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
                <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
                <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
                <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
                <label for="tel"><strong>TEL </strong></label>
                <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
                <label for="mail"><strong>MAIL </strong></label>
                <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
                <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
                <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
                <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
                <!-- SATEC -->
                <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
                <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
                <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
                <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>

                <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
                <label for="note"><strong>NOTE</strong></label>
                <input type="text" class="form-control" name="note" v-model="note">

                <label for="data_sopraluogo"><strong>DATA E ORA SOPRALUOGO</strong></label>
                <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
                <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
                <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec!= null">({{attivita_preventivate_satec.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
                <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
                <!-- ASCOM -->
                <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
                <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" required>
                <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
                <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" required>
                <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
                <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" required>
                <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
                <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" required>
              </form> 
            </div>
            <div v-else>
              <form>
                 <!-- ASCOM  -->
                <label for="azienda"><strong>AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
                <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
                <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
                <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
                <label for="tel"><strong>TEL </strong></label>
                <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
                <label for="mail"><strong>MAIL </strong></label>
                <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
                <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
                <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
                <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
                 <!-- SATEC  -->
                <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
                <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
                <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
                <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
                <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
                <label for="note"><strong>NOTE</strong></label>
                <input type="text" class="form-control" name="note" v-model="note">

                <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
                <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
                <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
                <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
              </form> 
            </div>
          </div>

          <div v-if="avanzamento == 5">
            <form>
              <!-- ASCOM -->
              <label for="azienda"><strong>AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
              <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
              <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
              <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
              <label for="tel"><strong>TEL </strong></label>
              <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
              <label for="mail"><strong>MAIL </strong></label>
              <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
              <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
              <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
              <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
              <!-- SATEC -->
              <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
              <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
              <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
              <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
              <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
              <label for="note"><strong>NOTE</strong></label>
              <input type="text" class="form-control" name="note" v-model="note">

              <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
              <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
              <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
              <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
              <!-- ASCOM -->
              <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
              <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" readonly>
              <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
              <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" readonly>
              
              <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" readonly>
              <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" readonly="readonly">
            </form> 
          </div>

          <!-- ASCOM -->
          <div v-if="avanzamento == 6">
            <div v-if="user_livello==1 || user_livello==4 || user_livello==5">
              <form>
                <!-- ASCOM -->
                <label for="azienda"><strong>AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
                <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
                <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
                <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
                <label for="tel"><strong>TEL </strong></label>
                <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
                <label for="mail"><strong>MAIL </strong></label>
                <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
                <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
                <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
                <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
                <!-- SATEC -->
                <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
                <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
                <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
                <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
                 
                <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
                <label for="note"><strong>NOTE</strong></label>
                <input type="text" class="form-control" name="note" v-model="note">

                <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
                <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
                <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
                <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo.length != null">({{attivita_preventivate_prezzo.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
                <!-- ASCOM -->
                <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
                <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" readonly>
                <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
                <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" readonly>
                
                <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
                <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" readonly>
                <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
                <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" readonly="readonly">
                <!-- SATEC -->
                <label for="tecnico_svolgimento"><strong>TECNICO SATEC PER SVOLGIMENTO ATTIVITA'</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico SATEC svolgimento" name="tecnico_svolgimento" v-model="tecnico_svolgimento" required>
                <label for="data_chiusura"><strong>DATA CHIUSURA LAVORO - INVIO PEC DOCUMENTI</strong></label>
                <input class="form-control" type="date" placeholder="09/03/2021" name="data_chiusura" v-model="data_chiusura" required>
                <label for="importo_fatturare"><strong>IMPORTO DA FATTURARE</strong></label>
                <input class="form-control" type="text" placeholder="importo_fatturare" name="importo_fatturare" v-model="importo_fatturare" required>
              </form> 
            </div>
            <div v-else>
              <form>
                 <!-- ASCOM  -->
                <label for="azienda"><strong>AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
                <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
                <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
                <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
                <label for="tel"><strong>TEL </strong></label>
                <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
                <label for="mail"><strong>MAIL </strong></label>
                <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
                <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
                <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
                <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
                <!-- SATEC  -->
                <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
                <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
                <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
                <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
                <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
                <label for="note"><strong>NOTE</strong></label>
                <input type="text" class="form-control" name="note" v-model="note">

                <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
                <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
                <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
                <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
                <!-- ASCOM  -->
                <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
                <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" readonly>
                <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
                <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" readonly>
                <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" readonly>
              <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" readonly="readonly">
              </form> 
            </div>
          </div>

          <div v-if="avanzamento == 7">
            <form>
              <!-- ASCOM -->
              <label for="azienda"><strong>AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
              <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
              <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
              <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
              <label for="tel"><strong>TEL </strong></label>
              <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
              <label for="mail"><strong>MAIL </strong></label>
              <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
              <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
              <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
              <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
              <!-- SATEC -->
              <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
              <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
              <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
              <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
              <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
              <label for="note"><strong>NOTE</strong></label>
              <input type="text" class="form-control" name="note" v-model="note">

              <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
              <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
              <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
              <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
                <!-- ASCOM -->
              <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
              <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" readonly>
              <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
              <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" readonly>
              <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" readonly>
              <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" readonly="readonly">
              <!-- SATEC -->
              <label for="tecnico_svolgimento"><strong>TECNICO SATEC PER SVOLGIMENTO ATTIVITA'</strong></label>
              <input class="form-control" type="text" placeholder="Tecnico SATEC svolgimento" name="tecnico_svolgimento" v-model="tecnico_svolgimento" readonly>
              <label for="data_chiusura"><strong>DATA CHIUSURA LAVORO - INVIO PEC DOCUMENTI</strong></label>
              <input class="form-control" type="date" placeholder="09/03/2021" name="data_chiusura" v-model="data_chiusura" readonly>
              <label for="importo_fatturare"><strong>IMPORTO DA FATTURARE</strong></label>
              <input class="form-control" type="text" placeholder="importo_fatturare" name="importo_fatturare" v-model="importo_fatturare" readonly>
            </form> 
          </div>

          <!-- SATEC -->
          <div v-if="avanzamento == 8">
            <div v-if="user_livello==1 || user_livello==4 || user_livello==5">
              <form>
                <!-- ASCOM -->
                <label for="azienda"><strong>AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
                <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
                <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
                <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
                <label for="tel"><strong>TEL </strong></label>
                <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
                <label for="mail"><strong>MAIL </strong></label>
                <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
                <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
                <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
                <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
                <!-- SATEC -->
                <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
                <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
                <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
                <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
                <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
                <label for="note"><strong>NOTE</strong></label>
                <input type="text" class="form-control" name="note" v-model="note">

                <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
                <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
                <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
                <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
                  <!-- ASCOM -->
                <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
                <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" readonly>
                <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
                <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" readonly>
                <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
                <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" readonly>
                <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
                <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" readonly="readonly">
                <!-- SATEC -->
                <label for="tecnico_svolgimento"><strong>TECNICO SATEC PER SVOLGIMENTO ATTIVITA'</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico SATEC svolgimento" name="tecnico_svolgimento" v-model="tecnico_svolgimento" readonly>
                <label for="data_chiusura"><strong>DATA CHIUSURA LAVORO - INVIO PEC DOCUMENTI</strong></label>
                <input class="form-control" type="date" placeholder="09/03/2021" name="data_chiusura" v-model="data_chiusura" readonly>
                <label for="importo_fatturare"><strong>IMPORTO DA FATTURARE</strong></label>
                <input class="form-control" type="text" placeholder="importo_fatturare" name="importo_fatturare" v-model="importo_fatturare" readonly>
                <!-- SATEC -->
                <label for="rif_ft"><strong>RIF. FT</strong></label>
                <input class="form-control" type="number" placeholder="rif_ft" name="rif_ft" v-model="rif_ft" required>
                <label for="pagato"><strong>PAGATO</strong></label>
                <input class="form-control" type="checkbox" placeholder="pagato" name="pagato" v-model="pagato">
              </form> 
            </div>
            <div v-else>
              <form>
                 ASCOM 
                <label for="azienda"><strong>AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
                <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
                <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
                <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
                <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
                <label for="tel"><strong>TEL </strong></label>
                <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
                <label for="mail"><strong>MAIL </strong></label>
                <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
                <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
                <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
                <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
                 SATEC 
                <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
                <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
                <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
                <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
                <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
                <label for="note"><strong>NOTE</strong></label>
                <input type="text" class="form-control" name="note" v-model="note">

                <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
                <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
                <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
                <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
                <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
                 ASCOM 
                <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
                <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" readonly>
                <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
                <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" readonly>
                <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
                <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" readonly>
                <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
                <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" readonly="readonly">
                 SATEC 
                <label for="tecnico_svolgimento"><strong>TECNICO SATEC PER SVOLGIMENTO ATTIVITA'</strong></label>
                <input class="form-control" type="text" placeholder="Tecnico SATEC svolgimento" name="tecnico_svolgimento" v-model="tecnico_svolgimento" readonly>
                <label for="data_chiusura"><strong>DATA CHIUSURA LAVORO - INVIO PEC DOCUMENTI</strong></label>
                <input class="form-control" type="date" placeholder="09/03/2021" name="data_chiusura" v-model="data_chiusura" readonly>
                <label for="importo_fatturare"><strong>IMPORTO DA FATTURARE</strong></label>
                <input class="form-control" type="text" placeholder="importo_fatturare" name="importo_fatturare" v-model="importo_fatturare" readonly>
              </form> 
            </div>
          </div>
          <div v-if="avanzamento == 9 && pagato == false">
            <form>
              <!-- ASCOM -->
              <label for="azienda"><strong>AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
              <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
              <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
              <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
              <label for="tel"><strong>TEL </strong></label>
              <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
              <label for="mail"><strong>MAIL </strong></label>
              <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
              <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
              <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
              <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
              <!-- SATEC -->
              <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
              <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
              <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
              <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
              <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
              <label for="note"><strong>NOTE</strong></label>
              <input type="text" class="form-control" name="note" v-model="note">

              <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
              <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
              <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
              <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
              <!-- ASCOM -->
              <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
              <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" readonly>
              <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
              <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" readonly>
              <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" readonly>
              <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" readonly="readonly">
              <!-- SATEC -->
              <label for="tecnico_svolgimento"><strong>TECNICO SATEC PER SVOLGIMENTO ATTIVITA'</strong></label>
              <input class="form-control" type="text" placeholder="Tecnico SATEC svolgimento" name="tecnico_svolgimento" v-model="tecnico_svolgimento" readonly>
              <label for="data_chiusura"><strong>DATA CHIUSURA LAVORO - INVIO PEC DOCUMENTI</strong></label>
              <input class="form-control" type="date" placeholder="09/03/2021" name="data_chiusura" v-model="data_chiusura" readonly>
              <label for="importo_fatturare"><strong>IMPORTO DA FATTURARE</strong></label>
              <input class="form-control" type="text" placeholder="importo_fatturare" name="importo_fatturare" v-model="importo_fatturare" readonly>
              <!-- SATEC -->
              <label for="rif_ft"><strong>RIF. FT</strong></label>
              <input class="form-control" type="number" placeholder="100" name="rif_ft" v-model="rif_ft" readonly>
              <p><label for="pagato"><strong>PAGATO</strong></label>
              <input class="form-control" type="checkbox" placeholder="pagato" name="pagato" v-model="pagato"></p>
            </form> 
          </div>

          <div v-if="avanzamento == 9 && pagato == true">
            <form>
              <!-- ASCOM -->
              <label for="azienda"><strong>AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Nome azienda" name="azienda" v-model="azienda" readonly>
              <label for="codice_fiscale"><strong>CODICE FISCALE </strong></label>
              <input class="form-control" type="text" placeholder="Codice fiscale" name="codice_fiscale" v-model="codice_fiscale" readonly>
              <label for="referente"><strong>REFERENTE AZIENDA </strong></label>
              <input class="form-control" type="text" placeholder="Referente azienda" name="referente" v-model="referente_azienda" readonly>
              <label for="tel"><strong>TEL </strong></label>
              <input class="form-control" type="text" placeholder="Telefono" name="tel" v-model="tel" readonly>
              <label for="mail"><strong>MAIL </strong></label>
              <input class="form-control" type="text" placeholder="Mail" name="mail" v-model="mail" readonly>
              <label for="sede"><strong>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Sede" name="sede" v-model="sede_sopraluogo" readonly>
              <label for="tipo_richiesta"><strong>TIPO RICHIESTA</strong></label>
              <input class="form-control" type="text" placeholder="Tipo richiesta" name="tipo_richiesta" v-model="tipo_richiesta" readonly>
              <!-- SATEC -->
              <p style="font-weight: bold;"><label for="chiamato"><strong>CLIENTE CONTATTATO</strong><input type="checkbox" class="form-control" name="chiamato" v-model="chiamato" readonly="readonly"></label></p>
              <p style="font-weight: bold;"><label for="appuntamento"><strong>APPUNTAMENTO FISSATO</strong><input type="checkbox" class="form-control" name="appuntamento" v-model="appuntamento" readonly="readonly"></label></p>
              <label for="data_appuntamento"><strong>DATA APPUNTAMENTO</strong></label>
              <input type="text" class="form-control" name="data_appuntamento" v-model="data_appuntamento" readonly>
              <p style="font-weight: bold;"><label for="chiamato_1"><strong>PRIMA CHIAMATA</strong><input type="checkbox" class="form-control" name="chiamato_1" v-model="chiamato_1"></label></p>
              <label for="note"><strong>NOTE</strong></label>
              <input type="text" class="form-control" name="note" v-model="note">

              <label for="data_sopraluogo"><strong>DATA E ORA SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="data/ora sopraluogo" name="data_sopraluogo" v-model="data_sopraluogo" readonly>
              <label for="tecnico_sopraluogo"><strong>TECNICO SOPRALLUOGO</strong></label>
              <input class="form-control" type="text" placeholder="Tecnico sopraluogo" name="tecnico_sopraluogo" v-model="tecnico_sopraluogo" readonly>
              <label for="attivita_preventivate_satec"><strong>ATTIVITA' PREVENTIVATE - PREZZO SATEC</strong><span v-if="attivita_preventivate_satec != null">({{attivita_preventivate_satec.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo SATEC" name="attivita_preventivate_satec" v-model="attivita_preventivate_satec" readonly>
              <label for="attivita_preventivate_prezzo"><strong>ATTIVITA' PREVENTIVATE -PREZZO DI VENDITA CONSIGLIATO</strong><span v-if="attivita_preventivate_prezzo != null">({{attivita_preventivate_prezzo.length}})</span></label>
              <input class="form-control" type="text" placeholder="Prezzo consigliato" name="attivita_preventivate_prezzo" v-model="attivita_preventivate_prezzo" readonly>
              <!-- ASCOM -->
              <label for="data_acc_preventivo"><strong>DATA ACCETTAZIONE PREVENTIVO</strong></label>
              <input class="form-control" type="date" placeholder="Data accettazione preventivo" name="data_acc_preventivo" v-model="data_acc_preventivo" readonly>
              <label for="attivita_confermate"><strong>ATTIVITA' CONFERMATE</strong></label>
              <input class="form-control" type="text" placeholder="Attivita confermate" name="attivita_confermate" v-model="attivita_confermate" readonly>
              <label for="data_invio_preventivo_cliente"><strong>DATA INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="date" name="data_invio_preventivo_cliente" v-model="data_invio_preventivo_cliente" readonly>
              <label for="invio_preventivo_cliente"><strong>INVIO PREVENTIVO CLIENTE</strong></label>
              <input class="form-control" type="checkbox" name="invio_preventivo_cliente" v-model="invio_preventivo_cliente" readonly="readonly">
              <!-- SATEC -->
              <label for="tecnico_svolgimento"><strong>TECNICO SATEC PER SVOLGIMENTO ATTIVITA'</strong></label>
              <input class="form-control" type="text" placeholder="Tecnico SATEC svolgimento" name="tecnico_svolgimento" v-model="tecnico_svolgimento" readonly>
              <label for="data_chiusura"><strong>DATA CHIUSURA LAVORO - INVIO PEC DOCUMENTI</strong></label>
              <input class="form-control" type="date" placeholder="09/03/2021" name="data_chiusura" v-model="data_chiusura" readonly>
              <label for="importo_fatturare"><strong>IMPORTO DA FATTURARE</strong></label>
              <input class="form-control" type="text" placeholder="importo_fatturare" name="importo_fatturare" v-model="importo_fatturare" readonly>
              <!-- SATEC -->
              <label for="rif_ft"><strong>RIF. FT</strong></label>
              <input class="form-control" type="number" placeholder="100" name="rif_ft" v-model="rif_ft" readonly>
              <p>
                <label for="pagato"><strong>PAGATO</strong>
                  <input class="form-control" type="checkbox" placeholder="pagato" name="pagato" v-model="pagato" readonly="readonly">
                </label>
              </p>
            </form> 
          </div>
          
          <div class="row">
            <div class="col-4">
              <div v-if="avanzamento > 3"><!--https://sviluppoallergeni.confcom.it-->
                <a :href="'https://sviluppoallergeni.confcom.it/pratica/'+id+'/docx'"  class="btn float-left" target="_blank" type="button" style="margin-bottom: 10px;background:#00467f;color:#ffffff"><i class="tim-icons icon-cloud-download-93"> </i> Template preventivo</a>
              </div>
            </div>
            <div class="col-8">
              <div v-if="avanzamento >= 3 && (user_livello == 1 || user_livello == 2 || user_livello == 3)">
                <!-- <label for="documento" style="font-weight: bold;">Carica documento</label> -->
                <button type="button"  style="background:#00467f" class="btn" onclick="document.getElementById('documento').click()">Carica documento</button>
                <input type="file" multiple name="documento" id="documento" ref="file" v-on:change="checkFileUpload()" style="display:none;margin-bottom: 20px;margin-top:12px; margin-left:25px">
                <!-- handleFileUpload() display:none; -->
              </div>
              <div v-else></div>
            </div>
          </div>
          <div class="row justify-content-start" style="margin-top:10px;" v-if="avanzamento >= 3"><!--&& (user_livello == 1 || user_livello == 2 || user_livello == 3)-->
            <div class="col">
              <div v-if="valori.PRATICA_META.length > 0" style="margin-top:15px">
                <p>File caricati:</p>
                <div v-for="value in valori.PRATICA_META" v-bind:key="value.ID">
                  <p><a :href="'https://sviluppoallergeni.confcom.it/static/documents/'+value.NAME + '?token='+accessToken" target="_blank" style="color:black">{{value.VALUE.name}}</a></p>
                </div>
              </div>
              <div v-else></div>
            </div>
            <div class="col"></div>
            <div class="col"></div>
          </div>
          <div class="row">
            <div class="col">          
              <router-link to="/dashboard" class="btn float-right" style="margin-bottom: 10px;background:#00467f">Indietro</router-link>
            </div>
            <div class="col">          
              <button class="btn float-right" type="button" v-on:click="salvaValori()" style="margin-bottom: 10px;background:#00467f">Salva</button>
            </div>
          </div>
        </card>
        
        <b-modal v-model="showCheckFile" size="md">
          <template #modal-header="{ close }">
              <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
          <template>
            <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
            <div class="container">
              <div id="preloader_3" v-if="showLoader"></div>
            </div>
          </template>
          <template #modal-footer="{ cancel }">
            <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
            <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import Card from '../components/Cards/Card.vue';
import PraticheServices from '@/services/PraticheServices';
import ChecklistServices from '@/services/ChecklistServices';
import Services from '@/services/Services';

  export default {
    name: 'modifica-dati',
    components: {
      Card
    },
    
    data() {
      return {
        prova_data: null, carica_prova: null,
        //ASCOM 1
        data_inserimento: null,
        azienda: null,
        codice_fiscale: null,
        referente_azienda: null,
        tel: null,
        mail: null,
        sede_sopraluogo: null,
        tipo_richiesta: null,
        check1: null,
        //SATEC 2
        chiamato: null,
        appuntamento: null,
        data_appuntamento: null,
        datetime_appuntamento: null,

        chiamato_1: false,
        note: null,
        data_sopraluogo: null,
        ora_sopraluogo: null,
        datetime_sopraluogo: null,
        tecnico_sopraluogo: null,
        attivita_preventivate_satec: null,
        attivita_preventivate_prezzo: null,
        data_invio_preventivo: null,
        check2: null,
        //ASCOM 2
        data_acc_preventivo: null,
        attivita_confermate: null,
        data_invio_preventivo_cliente: null,
        invio_preventivo_cliente: null,
        check3: null,
        //SATEC 2
        tecnico_svolgimento: null,
        data_chiusura: null,
        importo_fatturare: null,
        check4: '',
        //SATEC 3
        rif_ft: null,
        pagato: false,
        avanzamento: null,
       
        id: null,
        tipo_params: '',

        // attivita 
        attivita_array: [],
        nome_attivita: null, 
        prezzo_satec_attivita: null, 
        prezzo_consigliato_attiva: null,

        valori: [],
        token_response: [],
        save_response: [],

        showCheckFile: false,
        showLoader: false,
        file: null,
        fileCaricati: [],
        urlRichieste: 'https://sviluppoallergeni.confcom.it/',//'https://apiintranet.confcom.it/',

        //invio email
        email : null,
        rispostaEmail: "",

        id_checklist_sop: null
      }
    },

    computed: {},

    methods: {
      addAttivita: function() {
        if (this.nome_attivita != null && this.nome_attivita != '' && this.prezzo_satec_attivita != null && this.prezzo_satec_attivita != '' 
            && this.prezzo_consigliato_attiva !=  null && this.prezzo_consigliato_attiva != '') {
          this.attivita_array.push({NOME_ATTIVITA: this.nome_attivita, PREZZO_SATEC: this.prezzo_satec_attivita, PREZZO_CONSIGLIATO: this.prezzo_consigliato_attiva});
          this.nome_attivita = "";
          this.prezzo_satec_attivita = "";
          this.prezzo_consigliato_attiva = "";
        }
      },
      removeAttivita: function(index) {
        this.attivita_array.splice(index, 1);
      },
      
      caricaDati: async function() {
        let token = localStorage.getItem('access_token');
        let errore = 0;
        //RICHIESTA A /pratica/id così mi torna solo quella che mi serve
        await PraticheServices.caricaPratica(this.id)
        // await axios.get(
        //   this.urlRichieste + 'pratica/' + this.id,
        //   //'https://sviluppoallergeni.confcom.it/pratica/'+this.id, 
        //   {
        //     headers: {
        //       'Content-type': 'application/json',
        //       'Authorization': `Bearer ${token}`
        //     }
        //   }
        // )
        .then(response => { this.valori = response.data})
        .catch(function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
          }
        })
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) { await this.caricaDati()}
        }
        this.data_inserimento = this.valori.DATA_INSERIMENTO;
        this.azienda = this.valori.AZIENDA;
        this.codice_fiscale = this.valori.CF;
        this.referente_azienda = this.valori.REFERENTE_AZIENDA;
        this.tel = this.valori.TEL;
        this.mail = this.valori.MAIL;
        this.sede_sopraluogo = this.valori.SEDE;
        this.tipo_richiesta = this.valori.TIPO;
        this.check1 = this.valori.CHECK_1;
        /*
         chiamato: null,
        appuntamento: null,
        data_appuntamento: null,
        */
        this.chiamato = this.valori.CHIAMATO;
        this.appuntamento = this.valori.APPUNTAMENTO;
        this.datetime_appuntamento = this.valori.DATA_APPUNTAMENTO;

        this.chiamato_1 = this.valori.CHIAMATO_1;
        this.note = this.valori.NOTE;
        
        if (this.datetime_appuntamento != null) {
          if (this.valori.AVANZAMENTO <= 2) {
            this.data_appuntamento = this.getDateAnnoMeseGiorno(this.datetime_appuntamento) + "T" + this.getTime(this.datetime_appuntamento);
            console.log(`datetime_appuntamento= ${this.datetime_appuntamento} --- data_appuntamento = ${this.data_appuntamento}`);
          } else if (this.valori.AVANZAMENTO > 2) {
            this.data_appuntamento = this.getDate(this.datetime_appuntamento) + " " + this.getTime(this.datetime_appuntamento);
            console.log(`data_appuntamento = ${this.data_appuntamento}`);
          }
        }

        let data = this.valori.DATA_SOPRALLUOGO;
        this.datetime_sopraluogo = this.valori.DATA_SOPRALLUOGO;
        console.log(`datetime_sopraluogo = ${this.datetime_sopraluogo}`);
        if (this.datetime_sopraluogo != null) {
          this.data_sopraluogo = this.getDate(data) + " " + this.getTime(data);
          console.log(`data_sopralluogo = ${this.data_sopraluogo}`);
        }
        this.tecnico_sopraluogo = this.valori.TECNICO_SOPRALLUOGO;
        this.attivita_preventivate_prezzo = this.valori.PREZZO_CONSIGLIATO;
        this.attivita_preventivate_satec = this.valori.PREZZO_SATEC;
        this.data_invio_preventivo = this.valori.DATA_INVIO_PREVENTIVO;
        this.check2 = this.valori.CHECK_2;
        console.log(`check2: ${this.check2}`);
        this.data_acc_preventivo = this.valori.DATA_ACC_PREVENTIVO;
        this.attivita_confermate = this.valori.ATTIVITA_CONFERMATE;
        
        this.data_invio_preventivo_cliente = this.valori.DATA_INVIO_PREVENTIVO_CLIENTE;
        this.invio_preventivo_cliente = this.valori.INVIO_PREVENTIVO_CLIENTE;
        console.log(`data_invio_preventivo_cliente: ${this.data_invio_preventivo_cliente}  ---- invio_preventivo_cliente: ${this.invio_preventivo_cliente}`);
        this.check3 = this.valori.CHECK_3;
        this.tecnico_svolgimento = this.valori.TECNICO_SVOLGIMENTO;
        this.data_chiusura = this.valori.DATA_CHIUSURA;
        this.importo_fatturare = this.valori.IMPORTO_FATTURARE;
        this.check4 = this.valori.CHECK_4;
        this.rif_ft = this.valori.RIF_FT;
        this.pagato = this.valori.PAGATO;
        this.avanzamento = this.valori.AVANZAMENTO;
        this.fileCaricati = this.valori.PRATICA_META;
        this.id_checklist_sop = this.valori.ID_CHECKLIST_SOP
      },

      controllaDati: function() {
        this.datetime_sopraluogo = this.data_sopraluogo;
        console.log(`controllaDati datetime_sopraluogo: ${this.datetime_sopraluogo}`);
        // this.datetime_appuntamento = this.data_appuntamento
        if( this.avanzamento == 1){
          if( this.azienda == null || this.codice_fiscale == null || this.referente_azienda == null || this.tel == null
            || this.mail == null || this.sede_sopraluogo == null || this.tipo_richiesta == null){
              return false;
          } else {
            return true;
          }
        }
        else if( this.avanzamento == 2){
          // if( 
            // this.azienda == null || this.codice_fiscale == null || this.referente_azienda == null  || this.tel == null
            //   ||  this.mail == null  || this.sede_sopraluogo == null || this.tipo_richiesta == null 
            // ||  this.chiamato == null || this.appuntamento == null || this.datetime_appuntamento == null 
          //     this.datetime_sopraluogo == null || this.tecnico_sopraluogo == null 
          //     || this.attivita_preventivate_satec == null || this.attivita_preventivate_prezzo == null 
          //     ){
          //   return false;
          // } else {
            return true;
          // }
        }
        else if(this.avanzamento == 4){
          // if( 
          //   // this.azienda == null || this.codice_fiscale == null || this.referente_azienda == null || this.tel == null
          //   //   || this.mail == null || this.sede_sopraluogo == null || this.tipo_richiesta == null 
          //   //   || this.datetime_sopraluogo == null || this.tecnico_sopraluogo == null 
          //   //   || this.attivita_preventivate_satec == null  || this.attivita_preventivate_prezzo == null
          //   this.data_acc_preventivo == null  || this.attivita_confermate == null
          //     ){
          //   return false;
          // } else {
          //   return true;
          // }
          return true;
        }
        else if(this.avanzamento == 6){
          if( 
            // this.azienda == null || this.codice_fiscale == null || this.referente_azienda == null || this.tel == null
            //   || this.mail == null || this.sede_sopraluogo == null || this.tipo_richiesta == null 
            //   || this.datetime_sopraluogo == null || this.tecnico_sopraluogo == null 
            //   || this.attivita_preventivate_satec == null  || this.attivita_preventivate_prezzo == null
            //   || this.data_acc_preventivo == null  || this.attivita_confermate == null
            this.tecnico_svolgimento == null || this.importo_fatturare == null){
            return false;
          } else {
            return true;
          }
        }
        else if(this.avanzamento == 8 || this.avanzamento == 9){
          if( 
            // this.azienda == null || this.codice_fiscale == null || this.referente_azienda == null || this.tel == null
            //   || this.mail == null || this.sede_sopraluogo == null || this.tipo_richiesta == null 
            //   || this.datetime_sopraluogo == null || this.tecnico_sopraluogo == null 
            //   || this.attivita_preventivate_satec == null  || this.attivita_preventivate_prezzo == null
            //   || this.data_acc_preventivo == null  || this.attivita_confermate == null
            //   || this.tecnico_svolgimento == null || this.importo_fatturare == null
              this.rif_ft == null){
            return false;
          } else {
            return true;
          }
        } else {
          console.log("avanzamento diverso da valori possibili");
        }
      },

      salvaValori: async function() {
        let token = localStorage.getItem('access_token');
        let errore = 0;
        console.log(`avanzamento: ${this.avanzamento}`);
        if(!this.controllaDati()){
          alert("compilare tutti i dati");
        } else{
          let dati = [];
          console.log(`prima salvaValori()--> datetime_sopraluogo = ${this.datetime_sopraluogo}`);
          console.log(`prima salvaValori()--> datetime_appuntamento = ${this.datetime_appuntamento}`);
          // if (this.valori.DATA_SOPRALLUOGO != null) {
            
          // } else {
            
          // }
          if (this.valori.AVANZAMENTO <= 2) {
            this.datetime_appuntamento = this.data_appuntamento;
            this.datetime_sopraluogo = this.data_sopraluogo;
          } else {
            this.datetime_appuntamento = this.valori.DATA_APPUNTAMENTO;
            this.datetime_sopraluogo = this.valori.DATA_SOPRALLUOGO;
          }
          console.log(`salvaValori() --> datetime_sopraluogo = ${this.datetime_sopraluogo}`);
          console.log(`salvaValori() --> datetime_appuntamento = ${this.datetime_appuntamento}`);
          console.log(`data_accettazione: ${this.data_acc_preventivo} ---- data_invio_prev_cliente ${this.data_invio_preventivo_cliente}`)

          if( this.avanzamento == 1){
            dati.push({ AZIENDA: this.azienda, CF: this.codice_fiscale, REFERENTE_AZIENDA:this.referente_azienda, TEL:this.tel, MAIL:this.mail, SEDE:this.sede_sopraluogo, TIPO:this.tipo_richiesta});
          }
          if( this.avanzamento == 2){
            dati.push({ AZIENDA: this.azienda, CF: this.codice_fiscale, REFERENTE_AZIENDA:this.referente_azienda,TEL:this.tel, MAIL:this.mail, SEDE:this.sede_sopraluogo, TIPO:this.tipo_richiesta, CHECK_1: this.check1,
            CHIAMATO: this.chiamato, APPUNTAMENTO: this.appuntamento, DATA_APPUNTAMENTO: this.datetime_appuntamento, CHIAMATO_1: this.chiamato_1, NOTE: this.note,
            DATA_SOPRALLUOGO: this.datetime_sopraluogo, TECNICO_SOPRALLUOGO: this.tecnico_sopraluogo, PREZZO_CONSIGLIATO: this.attivita_preventivate_prezzo,
            PREZZO_SATEC:  this.attivita_preventivate_satec,/* DATA_INVIO_PREVENTIVO: this.data_invio_preventivo*/ });
          }
          if(this.avanzamento == 4){
            console.log("avanzamento 4 ora salvo valori");
            dati.push({ 
              AZIENDA: this.azienda, CF: this.codice_fiscale, REFERENTE_AZIENDA:this.referente_azienda,TEL:this.tel, MAIL:this.mail, SEDE:this.sede_sopraluogo, TIPO:this.tipo_richiesta, CHECK_1: this.check1,
            CHIAMATO: this.chiamato, APPUNTAMENTO: this.appuntamento, DATA_APPUNTAMENTO: this.datetime_appuntamento, CHIAMATO_1: this.chiamato_1, NOTE: this.note,
            DATA_SOPRALLUOGO: this.datetime_sopraluogo, TECNICO_SOPRALLUOGO: this.tecnico_sopraluogo,PREZZO_CONSIGLIATO: this.attivita_preventivate_prezzo,
            PREZZO_SATEC:  this.attivita_preventivate_satec,/* DATA_INVIO_PREVENTIVO: this.data_invio_preventivo,*/
             DATA_ACC_PREVENTIVO: this.data_acc_preventivo, ATTIVITA_CONFERMATE: this.attivita_confermate, CHECK_2: this.check2,
              DATA_INVIO_PREVENTIVO_CLIENTE: this.data_invio_preventivo_cliente, INVIO_PREVENTIVO_CLIENTE: this.invio_preventivo_cliente });
          }
          if(this.avanzamento == 6){
            dati.push({ AZIENDA: this.azienda, CF: this.codice_fiscale, REFERENTE_AZIENDA:this.referente_azienda,TEL:this.tel, MAIL:this.mail, SEDE:this.sede_sopraluogo, TIPO:this.tipo_richiesta, CHECK_1: this.check1,
            CHIAMATO: this.chiamato, APPUNTAMENTO: this.appuntamento, DATA_APPUNTAMENTO: this.datetime_appuntamento, CHIAMATO_1: this.chiamato_1, NOTE: this.note,
            DATA_SOPRALLUOGO: this.datetime_sopraluogo, TECNICO_SOPRALLUOGO: this.tecnico_sopraluogo, PREZZO_CONSIGLIATO: this.attivita_preventivate_prezzo,
            PREZZO_SATEC:  this.attivita_preventivate_satec, /* DATA_INVIO_PREVENTIVO: this.data_invio_preventivo,*/ DATA_ACC_PREVENTIVO: this.data_acc_preventivo,ATTIVITA_CONFERMATE: this.attivita_confermate, CHECK_2: this.check2,
            DATA_INVIO_PREVENTIVO_CLIENTE: this.data_invio_preventivo_cliente, INVIO_PREVENTIVO_CLIENTE: this.invio_preventivo_cliente,
            TECNICO_SVOLGIMENTO: this.tecnico_svolgimento, DATA_CHIUSURA: this.data_chiusura, IMPORTO_FATTURARE: this.importo_fatturare });
          }
          if(this.avanzamento == 8){
            dati.push({
              AZIENDA: this.azienda, CF: this.codice_fiscale, REFERENTE_AZIENDA:this.referente_azienda,TEL:this.tel, MAIL:this.mail, SEDE:this.sede_sopraluogo, TIPO:this.tipo_richiesta, CHECK_1: this.check1,
              CHIAMATO: this.chiamato, APPUNTAMENTO: this.appuntamento, DATA_APPUNTAMENTO: this.datetime_appuntamento, CHIAMATO_1: this.chiamato_1, NOTE: this.note,
              DATA_SOPRALLUOGO: this.datetime_sopraluogo, TECNICO_SOPRALLUOGO: this.tecnico_sopraluogo, PREZZO_CONSIGLIATO: this.attivita_preventivate_prezzo,
            PREZZO_SATEC:  this.attivita_preventivate_satec, /* DATA_INVIO_PREVENTIVO: this.data_invio_preventivo,*/ DATA_ACC_PREVENTIVO: this.data_acc_preventivo, ATTIVITA_CONFERMATE: this.attivita_confermate, CHECK_2: this.check2, 
              DATA_INVIO_PREVENTIVO_CLIENTE: this.data_invio_preventivo_cliente, INVIO_PREVENTIVO_CLIENTE: this.invio_preventivo_cliente,
              TECNICO_SVOLGIMENTO: this.tecnico_svolgimento, DATA_CHIUSURA: this.data_chiusura, IMPORTO_FATTURARE: this.importo_fatturare, CHECK_3: this.check3,
              RIF_FT: this.rif_ft, PAGATO: this.pagato
            });
          } 
          if(this.avanzamento == 9){
            dati.push({
              AZIENDA: this.azienda, CF: this.codice_fiscale, REFERENTE_AZIENDA:this.referente_azienda,TEL:this.tel, MAIL:this.mail, SEDE:this.sede_sopraluogo, TIPO:this.tipo_richiesta, CHECK_1: this.check1,
              CHIAMATO: this.chiamato, APPUNTAMENTO: this.appuntamento, DATA_APPUNTAMENTO: this.datetime_appuntamento, CHIAMATO_1: this.chiamato_1, NOTE: this.note,
              DATA_SOPRALLUOGO: this.datetime_sopraluogo, TECNICO_SOPRALLUOGO: this.tecnico_sopraluogo, PREZZO_CONSIGLIATO: this.attivita_preventivate_prezzo,
              PREZZO_SATEC:  this.attivita_preventivate_satec, /* DATA_INVIO_PREVENTIVO: this.data_invio_preventivo,*/ DATA_ACC_PREVENTIVO: this.data_acc_preventivo, ATTIVITA_CONFERMATE: this.attivita_confermate,/* CHECK_2: this.check2,*/
              DATA_INVIO_PREVENTIVO_CLIENTE: this.data_invio_preventivo_cliente, INVIO_PREVENTIVO_CLIENTE: this.invio_preventivo_cliente,
              TECNICO_SVOLGIMENTO: this.tecnico_svolgimento, DATA_CHIUSURA: this.data_chiusura, IMPORTO_FATTURARE: this.importo_fatturare, CHECK_3: this.check3,
              RIF_FT: this.rif_ft, PAGATO: this.pagato
            });
          }
          else {
            console.log("avanzamento diverso da valori possibili");
          }
          let datiJSON=JSON.stringify(dati[0]);
          console.log(datiJSON);
          await PraticheServices.updatePratica(this.id, datiJSON)
          // await axios.put(
          //   //'https://sviluppoallergeni.confcom.it/pratica/'+this.id, 
          //   this.urlRichieste + 'pratica/' + this.id,
          //   datiJSON,
          //   { 
          //     headers: {
          //       'Content-type': 'application/json',
          //       'Authorization': `Bearer ${token}`
          //     }
          //   })
          .then(response => { this.save_response = response.data})
          .catch( function (error) {
            // handle error
            console.log(`error.response.status = ${error.response.status}`);
            if(error.response.status == 401){
              errore = error.response.status;
            }
          })
          if (errore == 401) {
            let value =await this.refreshToken();
            if (value) { await this.salvaValori(); }
          }
          this.$router.push({
            path: '/dashboard'
          })
        }
      },

      refreshToken: async function(){
        let errore = 0;
        await Services.refreshToken()
        // await axios.post(
        //   this.urlRichieste + 'token',
        //   //"https://sviluppoallergeni.confcom.it/token",
        //   {
        //     withCredentials: true,
        //     headers: {
        //       'Content-type': 'application/json',
        //     }
        //   }
        // )
        .then(response => { this.token_response = response.data})
        .catch(function (error) {
          // handle error
          if(error.response.status == 403 || error.response.status == 401){
            errore = error.response.status;
            //this.logout()
          }
        })
        if(errore == 403 || errore == 401){
          console.log(`errore = ${errore}`);
          await this.logout();
          return false;
        }
        localStorage.setItem('access_token', this.token_response.accessToken);
        return true;
      },

      logout: async function () {
        //let ris = await logout.UserServices()
        //let token = localStorage.getItem("access_token");
        await Services.logout()
        // await axios.delete(
        //   this.urlRichieste + 'logout',
        //   //'https://sviluppoallergeni.confcom.it/logout',
        //     {
        //     withCredentials: true,
        //     headers: {
        //       'Content-type': 'application/json',
        //       //'Authorization': `Bearer ${token}`
        //     }
        //   }
        // )
        .then(response => { this.results = response.data})
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.setItem('isLogged', false);
        localStorage.removeItem('user_nome');
        localStorage.removeItem('user_cognome');
        localStorage.removeItem('user_tipologia');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_livello');
        localStorage.removeItem('user_id');
        this.$router.push({
          path: '/login'
        })
        // window.location.reload()
      },

      checkFileUpload: function() {
        this.showCheckFile = true;
      },

      handleFileUpload: async function(){
        this.showLoader = true;
        console.log(`showLoader = ${this.showLoader}`);
        let token = localStorage.getItem('access_token');
        let risposta;
        let errore = 0;
        this.file = this.$refs.file.files[0];
        let formData = new FormData()
        formData.append('documento', this.file)
        // await PraticheServices.uploadFile(this.id, formData)
        await axios.post(
          this.urlRichieste + 'pratica/'+this.id+'/meta',
          //'https://sviluppoallergeni.confcom.it/pratica/'+this.id+'/meta',
          formData,
            {
            withCredentials: true,
            headers: {
              'Content-type': 'multipart/form-data',
              'Authorization': `Bearer ${token}`
            }
          }
        )
        .then(response => { risposta = response.data})
        .catch( function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
          }
        })
        if (errore == 401) {
          console.log(`errore 401`);
          let value = await this.refreshToken();
          if (value) { await this.handleFileUpload(); }
        }
        this.showCheckFile = false;
        this.showLoader = false;
        await this.caricaDati();
      },
      
      handleremoveFile: function(){
        this.file = null;
      },

      getDate(datetime) {
        return moment(String(datetime)).format('DD/MM/YYYY');
      },
      getDateAnnoMeseGiorno(datetime) {
        return moment(String(datetime)).format('YYYY-MM-DD');
      },

      getTime(datetime){
        //datetime_appuntamento= 2021-12-05T22:01:00.000Z --- data_appuntamento = 2021-12-05T23:01
        let text = "2021-12-05T22:01:00.000Z"; //2021-12-05T23:01
        const myArray = datetime.split("-");
        // console.log(myArray);
        const arr =  myArray[myArray.length-1].split(":");
        // console.log(arr);
        const ora= arr[0].substring(3,5);
        const min = arr[1];
        const time = ora + ":" + min;
        // console.log(ora+ ":"+arr[1]);
        return time;
        //return moment(String(datetime)).format("HH:mm");
      },

      inviaEmail: async function(){
        if(this.email == null)
          return
        else{
          const dati = {mail : this.email, idPratica : this.id}
          let errore = 0;
          await ChecklistServices.inviaEmail(dati) 
          .then(response => { rispostaEmail = response.message})
          .catch( function (error) {
              if(error.response.status == 401){
                  errore = error.response.status;
          }
          });
          if (errore == 401) {
              let value = await Services.refreshTokenFunction();
              if (value) { await this.inviaEmail(); }
          }
        }
      },

      checklist: async function(){
        window.location.href = 'https://testvetrine.hrsconfcom.it/#/checklist?id=' + this.id_checklist_sop
      },

      main: async function() {
        this.id = this.$route.query.id;
        //console.log("id = " + this.id)
        axios.defaults.withCredentials = true;
        this.user_livello = localStorage.getItem('user_livello');
        //console.log("user_livello" + this.user_livello)
        this.accessToken = localStorage.getItem('access_token');
        try {
          await this.caricaDati();
        } catch (error) {
          console.log(`error try/catch = ${error}`);
          console.log(`error.response try/catch = ${error.response}`);
          console.log(`error.response.status try/catch = ${error.response.status}`);
          if (error.response.status == 401) {
            await this.refreshToken();
          }
        }
      }
    },

    mounted() {
      this.main();
    } 
  };
</script>
<style>
body {
  font-family: Roboto,sans-serif;
}
button, input, optgroup, select, textarea {
  font-family: Roboto,sans-serif;
}

/* input:invalid {
  border: 2px solid red;
} */

input:invalid:required {
  border: 2px solid red;
}

input:required:placeholder-shown {
  /* border-color: red; */
  border: 2px solid red;
}

input:required:valid {
  border: 2px solid green;
}

#preloader_3{
    /* position:relative; */
    display: flex;
  justify-content: center;
}
#preloader_3:before{
	width:20px;
	height:20px;
	border-radius:20px;
	background:blue;
	content:'';
	/* position:absolute; */
  display: flex;
  justify-content: center;
	background:#9b59b6;
	animation: preloader_3_before 1.5s infinite ease-in-out;
}

#preloader_3:after{
	width:20px;
	height:20px;
	border-radius:20px;
	background:blue;
	content:'';
	/* position:absolute; */
  display: flex;
  justify-content: center;
	background:#2ecc71;
	left:22px;
	animation: preloader_3_after 1.5s infinite ease-in-out;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
	font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
padding-right: 0;
}

.input-icon-right > i {
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 25px;
  text-align: right;
}

@keyframes preloader_3_before {
    0% {transform: translateX(0px) rotate(0deg)}
    50% {transform: translateX(50px) scale(1.2) rotate(260deg); background:#2ecc71;border-radius:0px;}
      100% {transform: translateX(0px) rotate(0deg)}
}
@keyframes preloader_3_after {
    0% {transform: translateX(0px)}
    50% {transform: translateX(-50px) scale(1.2) rotate(-260deg);background:#9b59b6;border-radius:0px;}
  	100% {transform: translateX(0px)}
}
</style>
